import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { CircularAvatar } from "../../commons";

import { PaperClipIcon } from "../../Icon";
import { viewEyeGray } from "../../../assets/images";
import { PerformanceEvaluationListType } from "../../../redux/mySpace/mySpaceTypes";
type AppProps = {
  tableHeader: TableHeadersType[];
  data: [] | PerformanceEvaluationListType[];
  type?: string;
  isMyCheckInsEditPresent?: boolean;
  toggleSubmitManagerFeedback?: (data: any) => void;
  handleViewPerformanceEvaluationDetails?:(id:string)=>void;
};

const PerformanceEvaluationTableData = ({
  tableHeader,
  data,
  type,
  toggleSubmitManagerFeedback,
  handleViewPerformanceEvaluationDetails
}: AppProps) => {
  return (
    <>
      {data?.length > 0 &&
        data?.map((el: PerformanceEvaluationListType) => {
          return (
            <tr className="text-left">
              {tableHeader?.length > 0 &&
                tableHeader?.map((header: TableHeadersType) => {
                  const myPEFormActionButton = !el?.feedback?.length
                    ? "Submit Feedback"
                    : "View Feedback";
                  if (header?.value === "title") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "120px" }}
                      >
                        {el?.title ? el?.title : "NA"}
                      </td>
                    );
                  } else if (header?.value === "employee_id") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "120px" }}
                      >
                        {el?.created_by?.employee_id ? el?.created_by?.employee_id : "NA"}
                      </td>
                    );
                  }
                  else if (header?.value === "hours") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "120px" }}
                      >
                        {el?.hours ? el?.hours : "NA"}
                      </td>
                    );
                  }
                  else if (header?.value === "manager") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "200px" }}
                      >
                        <div className="d-flex">
                          <CircularAvatar
                            name={`${el?.manager?.first_name} ${
                              el?.manager?.last_name
                                ? el?.manager?.last_name
                                : ""
                            }`}
                            image={
                              el?.manager?.profile_pic &&
                              el?.manager.profile_pic?.file_url
                            }
                          />
                          <div className="ml-2">
                            <p className="mb-0">{`${el?.manager?.first_name} ${
                              el?.manager?.last_name
                                ? el?.manager?.last_name
                                : ""
                            }`}</p>
                            <p
                              style={{
                                margin: "0px",
                                fontSize: "12px",
                                color: "#6e7491",
                              }}
                            >
                              {el?.manager?.job_title}
                            </p>
                            <p
                              style={{
                                margin: "0px",
                                fontSize: "12px",
                                color: "#6e7491",
                              }}
                            >
                              {el?.manager?.department}
                            </p>
                          </div>
                        </div>
                      </td>
                    );
                  }
                  else if (header?.value === "first_name") {
                    return (
                      <td
                        className="text-left mt-5"
                        style={{ minWidth: "200px" }}
                      >
                        <div className="d-flex">
                          <CircularAvatar
                            name={`${el?.created_by?.first_name} ${
                              el?.created_by?.last_name
                                ? el?.created_by?.last_name
                                : ""
                            }`}
                            image={
                              el?.created_by?.profile_pic &&
                              el?.created_by.profile_pic?.file_url
                            }
                          />
                          <div className="ml-2">
                            <p className="mb-0" 
                             style={{
                              margin: "0px",
                              color: "#262a44",
                              fontWeight: "500",
                              fontSize: "14px",
                              textDecoration:
                                type === "hrms" ? "underline" : "",
                              textUnderlineOffset:
                                type === "hrms" ? "2px" : "",
                              cursor: type === "hrms" ? "pointer" : "default",
                            }}
                            onClick={() =>
                              type === "hrms" &&
                              handleViewPerformanceEvaluationDetails?.(el?._id)
                            }
                            >{`${el?.created_by?.first_name} ${
                              el?.created_by?.last_name
                                ? el?.created_by?.last_name
                                : ""
                            }`}</p>
                            <p
                              style={{
                                margin: "0px",
                                fontSize: "12px",
                                color: "#6e7491",
                              }}
                            >
                              {el?.created_by?.job_title}
                            </p>
                            <p
                              style={{
                                margin: "0px",
                                fontSize: "12px",
                                color: "#6e7491",
                              }}
                            >
                              {el?.created_by?.department}
                            </p>
                          </div>
                        </div>
                      </td>
                    );
                  }
                  else if (header?.value === "rating") {
                    return (
                      <td className="text-left mt-5">
                        <p style={{ margin: "0px" }}>
                          {el?.rating ? el?.rating : "NA"}
                        </p>
                      </td>
                    );
                  } 
                  else if (header?.value === "end_date") {
                    return (
                      <td className="text-left mt-5" style={{minWidth:'167px'}}>
                        <p style={{ margin: "0px" }}>
                          {`${el?.start_date} to ${el?.end_date}`}
                        </p>
                      </td>
                    );
                  }
                  else if (header?.value === "feedback") {
                    return (
                      <td
                        className="text-left mt-5 "
                        style={{ minWidth: "150px" }}
                      >
                        <div className="d-flex align-items-center">
                          <span className="ml-2">
                            {el?.feedback ? el?.feedback : "NA"}
                          </span>
                        </div>
                      </td>
                    );
                  } else if (header?.value === "file_attachment") {
                    const totalAttachments = (el?.file_attachment?.length || 0) + (el?.manager_file_attachment?.length || 0);
                
                    return totalAttachments > 0 ? (
                        <td className="position-relative">
                            <span>
                                <PaperClipIcon />
                                <span className="badge count-badge">{totalAttachments}</span>
                            </span>
                        </td>
                    ) : (
                        <td> --/-- </td>
                    );
                }                
                   else if (header?.value == "action") {
                    return (
                      <td style={{ minWidth: "142px", textAlign: "start" }}>
                        <div>
                          {
                            <span
                              style={{ display: "flex", alignItems: "center" }}
                              className=" pointer"
                            >
                              <div>
                                <button
                                  className={`btn w-100 ${
                                    type !== "MYPE"
                                      ? myPEFormActionButton === "View Feedback"
                                        ? "btn-outline"
                                        : "btn-primary"
                                      : ""
                                  }`}
                                  onClick={() =>
                                    toggleSubmitManagerFeedback?.(el)
                                  }
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  {type == "MYPE" ? (
                                    <img src={viewEyeGray} />
                                  ) : (
                                    myPEFormActionButton
                                  )}
                                </button>
                              </div>
                            </span>
                          }
                        </div>
                      </td>
                    );
                  }
                })}
            </tr>
          );
        })}
    </>
  );
};

export default PerformanceEvaluationTableData;
